import React from 'react';

import Page from 'components/Page';
import VideoPopup from 'components/VideoPopup';


const VideoTemplate = ({ page: { acf: { video, image } } }) => {
    
    return (
        <Page>
            <VideoPopup video={video} image={image} />
        </Page>
    );
};


export default VideoTemplate;
